<template>
    <b-container class="p-0">
        <div class="rw-choose-correct-answer2">
            <b-row>
                <b-col cols="12" v-if="qdata.image">
                    <div class="question-item__image">
                        <img class="mw-100" :src="imageSrc(qdata.image.data.src)" alt="">
                    </div>
                </b-col>
                <b-col cols="12" v-if="qdata.label2">
                    <div class="ql-editor" v-if="qdata.label2" v-html="qdata.label2.data.value"></div>
                </b-col>
            </b-row>
            <div class="question-example mt-4">
                <p class="text-start section-title mb-0"><strong>Example</strong></p>
                <div class="example__block border p-2 rounded">
                    <img class="mw-100" :src="exampleImage" alt="" v-if="!qdata.example">
                    <b-row v-if="qdata.example">
                        <b-col cols="12" class="mb-3 text-start">
                            <div class="question-block mb-1 d-flex">
                                <div class="question-character">
                                    <p class="m-0"><strong>{{ qdata.example.character_name.data.value }}</strong></p>
                                </div>
                                <div class="question-text">
                                    <p class="m-0">{{ qdata.example.question.data.value }}</p>
                                </div>
                            </div>
                            <div class="answer-option d-flex">
                                <div class="question-character">
                                    <p class="m-0"><strong>{{ qdata.example.answer.character_name.data.value }}</strong></p>
                                </div>
                                <div class="answer-option">
                                    <div class="option-item mb-1" v-for="(optionItem, optionIndex) in qdata.example.answer.options" :key="optionIndex" :class="{ 'selected': optionItem.isTrue }">
                                        {{ optionItem.asnwer_text.data.value }}
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <b-row v-if="qdata.questions" class="mt-4">
                <p class="text-start section-title mb-0"><strong>Questions</strong></p>
                <b-col cols="12" v-for="(item, index) in qdata.questions" :key="index" class="mb-3 text-start">
                    <div class="question-block mb-1 d-flex">
                        <div class="question-character">
                            <p class="m-0"><strong>{{ item.character_name.data.value }}</strong></p>
                        </div>
                        <div class="question-text">
                            <p class="m-0">{{ item.question.data.value }}</p>
                        </div>
                    </div>
                    <div class="answer-option d-flex">
                        <div class="question-character">
                            <p class="m-0"><strong>{{ item.answer.character_name.data.value }}</strong></p>
                        </div>
                        <div class="answer-option">
                            <div class="option-item mb-1" v-for="(optionItem, optionIndex) in item.answer.options" :key="optionIndex" :class="{ 'selected': optionIndex == item.answer.choose && item.answer.choose !== '' }" @click="chooseAnswer(index, optionIndex)">
                                {{ optionItem.asnwer_text.data.value }}
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>

<script>

import {
    BRow,
    BCol,
    BContainer
} from 'bootstrap-vue'

export default {
    name: 'rw_choose_corect_answer2',
    components: {
        BRow,
        BCol,
        BContainer,
    },
    props: {
        qdata: Object
    },
    created() {
        if (this.qdata.questions) {
            for (let index = 0; index < this.qdata.questions.length; index++) {
                this.$set(this.qdata.questions[index].answer, 'choose', '')
                this.answer[index] = null
            }
        }
    },
    data () {
        return {
            questionChooseAnswer: null,
            answer: [],
            imageDefault: require('@/assets/img-default.jpg'),
            exampleImage: require('@/assets/kidbox-example/rw_choose_correct_answer.png'),
        }
    },
    methods: {
        chooseAnswer(questionIndex, answerIndex) {
            this.answer[questionIndex] = answerIndex
            this.qdata.questions[questionIndex].answer.choose = answerIndex
            this.$emit('input', {
                answers: this.answer
            })
        },
        imageSrc (src) {
            if (src && src !== '') { return src }
            return this.imageDefault
        }
    }
}
</script>

<style scoped>


#choose_answer_modal .correct-answer-item {
    background-color: #ffdeb2;
    padding: 5px 15px;
    border-radius: 5px;
    cursor: pointer;
}

.question-item .question {
    font-weight: 500;
}

.question-item .answer-choose {
    min-height: 40px;
    background-color: #fff;
    margin-top: 10px;
    margin-bottom: 10px;
    border: 1px solid #c3c3c3;
    border-radius: 5px;
    cursor: pointer;
    padding: 6px;
}

.question-item {
    background-color: #e3e3e3;
    padding: 5px 10px;
    border-radius: 3px;
    margin-bottom: 20px;
}

.question-character {
    max-width: 140px;
    min-width: 100px;
    font-family: 'SFU Futura';
    font-size: 1.3rem;
    color: #25661f;
}

.question-text {
    font-family: 'FS Ariston Comic Base';
    font-size: 1.6rem;
    color: #333;
}

.option-item {
    cursor: pointer;
    font-family: 'FS Ariston Comic Base';
    font-size: 1.6rem;
    line-height: 1.5rem;
    color: #1177f3;
    padding: 10px 20px;
    background-color: #cfecfb;
    margin-bottom: 10px !important;
    border-radius: 5px;
}

.option-item.selected {
    color: #fff;
    background-color: #e35707;
}

.option-item:hover {
    color: #cd4f09;
}

.option-item.selected:hover {
    color: #fff;
}

</style>